import { Prompt } from 'features/textGenerator/store/types';

// 10 is an arbitrary value chosen by Gordian together with DS
export const maxTextItemCount = 10;

export function getNTextItems(prompt: Prompt | undefined | null) {
  // 2 is an arbitrary value chosen by Gordian
  return Math.min(maxTextItemCount, prompt?.nTextItems || 2);
}
